export const gradientAnimation =
  "duration-10 animate-gradient-10s bg-gradient-to-br from-primary via-primary-extraLight to-yellow bg-size-200 bg-clip-text bg-pos-0 font-bold text-transparent ";

export const getTranslateYAnimation = (translateAnimation: boolean) => {
  return ` opacity-0 duration-700 ease-in-out  ${
    translateAnimation ? "translate-y-0 opacity-100" : "translate-y-12"
  }`;
};
